/**
 * 앱 전역 토스트 — 발화(fireToast)와 수신(ToastHost 리스너)의 단일 계약.
 * 스펙 F §5(.toast-wrap/.toast). ToastHost가 TOAST_EVENT를 수신해 일정 시간 표시하며,
 * AppShell(인증 화면)과 로그인 등 공개 화면 양쪽에 마운트되어 어디서든 토스트가 뜸.
 */

/** 전역 토스트 커스텀 이벤트 이름 (발화·수신 단일 출처). */
export const TOAST_EVENT = "eqms-toast";

/** 토스트 종류 — 아이콘·색상 결정. 기본 'ok'(성공, 초록). 'warn'=경고(노랑). */
export type ToastVariant = "ok" | "warn";

/** 토스트 페이로드. */
export interface ToastDetail {
  title: string;
  sub?: string;
  variant?: ToastVariant;
}

/**
 * 앱 전역 토스트 발화 — ToastHost의 TOAST_EVENT 리스너가 수신해 표시.
 * @param variant 'ok'(기본, 성공/초록) | 'warn'(경고/노랑)
 */
export function fireToast(title: string, sub?: string, variant: ToastVariant = "ok"): void {
  window.dispatchEvent(
    new CustomEvent<ToastDetail>(TOAST_EVENT, { detail: { title, sub, variant } }),
  );
}
